module.exports = __webpack_public_path__ + "img/mco.cbcdb6c0.png";